import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import Header from "../../../layouts/Header.js";
import {
  singleUploadToS3,
  multipleUploadToS3,
  filesInsertDocToS3,
  UpdateProjectCover,
  DriveAdd,
  DriveUpdate,
  FetchSpireFolderDocuments,
  AddRootDoc,
  fileChunkStart,
  filePresign,
  fileChunkComplete,
  fileChunkAbort,
  ajitJsonSpireApi,
} from "../../../redux/actions/action.js";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../../redux/constants/type.js";
import { Tooltip } from "antd";
import { FolderOutlined, FileImageOutlined } from "@ant-design/icons";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Loader from "../../../components/Dailogs/Loader";
import PlusImg from "../../../assets/icons/plus-circle-white.svg";
import AIicon from "../../../assets/icons/AIicon.svg";
import PlusImgDotted from "../../../assets/icons/plus-dotted-blue-icon.svg";
import PlusImg2 from "../../../assets/icons/plus-circle2.svg";
import searchicon from "../../../assets/icons/search.svg";
import xCircle from "../../../assets/icons/x-circle.svg";
import "../../../assets/styles/local/SpireAI.css";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";
import { handleGeneralNotification } from "../../../utils/helpers/notifications";
import { ProgressBar } from "react-bootstrap";
import { toast } from "react-toastify";
import LogoSmall from "../../../assets/images/logo-small.png";
import roundFileSize from "../../../utils/Documents/roundFileSize";

const DragDropSpireAi = (props) => {
  const dispatch = useDispatch();
  const [Ankit] = useAutoAnimate();
  const history = useHistory();
  const location = useLocation();
  const { folderID } = useParams();
  const path = location.pathname;
  const hidden_Input_File = useRef(null);
  const single_Input_File = useRef(null);
  const workspaceName = window.localStorage.getItem("workspaceName");

  const singleUploadToS3Res = useSelector(
    (state) => state.user.singleUploadToS3Res,
  );

  const multipleUploadToS3Res = useSelector(
    (state) => state.user.multipleUploadToS3Res,
  );

  const fetchSpireFolderDocumentsRes = useSelector(
    (state) => state.user.fetchSpireFolderDocumentsRes,
  );

  const driveAddFolderRes = useSelector(
    (state) => state.user.driveAddFolderRes,
  );

  const driveUpdateFolderRes = useSelector(
    (state) => state.user.driveUpdateFolderRes,
  );

  const filesInsertDocToS3Res = useSelector(
    (state) => state.user.filesInsertDocToS3Res,
  );

  const addDocRootRes = useSelector((state) => state.user.addDocRootRes);

  const fileChunkStartRes = useSelector(
    (state) => state.user.fileChunkStartRes,
  );
  const filePresignRes = useSelector((state) => state.user.filePresignRes);
  const fileChunkCompleteRes = useSelector(
    (state) => state.user.fileChunkCompleteRes,
  );
  const fileChunkAbortRes = useSelector(
    (state) => state.user.fileChunkAbortRes,
  );
  console.log("asc chunk22", fileChunkStartRes);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Spire_AI").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [errorMsg, setErrorMsg] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [fileFolderPopup, setFileFolderPopup] = useState(false);
  const [isRootFileAdding, setIsRootFileAdding] = useState(false);
  const [isFolderAdding, setIsFolderAdding] = useState(false);
  const [fetchFolderData, setFetchFolderData] = useState([]);
  const [folderStructure, setFolderStructure] = useState([]);
  const [currentFile, setCurrentFile] = useState();

  useEffect(() => {
    // dispatch(FetchSpireFolderDocuments(folderID));
  }, []);

  useEffect(() => {
    if (driveAddFolderRes || driveUpdateFolderRes) {
      setIsFolderAdding(false);
    }
  }, [driveAddFolderRes, driveUpdateFolderRes]);

  const progressCountRef = useRef({ current: 0, total: 0 });

  let toastId = null;

  const showOrUpdateUploadToast_old = (progress, done = false) => {
    if (!toastId) {
      // Ek hi toast create hoga
      toastId = toast(
        <ProgressBarNotification progress={progress} done={done} />,
        { autoClose: false, closeOnClick: false },
      );
    } else {
      // Update hoga wahi toast
      toast.update(toastId, {
        render: <ProgressBarNotification progress={progress} done={done} />,
        autoClose: done ? 2000 : false, // complete hone par close ho jaye
      });
    }
  };

  const ProgressBarNotification_old = ({ progress, done }) => (
    <div className="app-notification-container mt-22">
      <div className="d-flex align-items-center gap-2">
        <img src={LogoSmall} width={35} alt="" />
        <div className="d-flex flex-column gap-1 w-100">
          <div>
            {done
              ? "Document Uploaded successfully!"
              : "Your document is loading..."}
            {/* : `Your document is loading... 
                ${progressCountRef.current.part} of
                ${progressCountRef.current.total}`} */}
          </div>
          {!done && (
            <ProgressBar now={progress} className="notification-progress-bar" />
          )}
        </div>
      </div>
    </div>
  );

  const showOrUpdateUploadToast = (
    progressOrMsg,
    done = false,
    error = false,
  ) => {
    if (!toastId) {
      toastId = toast(
        <ProgressBarNotification
          progress={typeof progressOrMsg === "number" ? progressOrMsg : 0}
          done={done}
          error={error}
          message={typeof progressOrMsg === "string" ? progressOrMsg : null}
        />,
        { autoClose: error ? 3000 : done ? 2000 : false, closeOnClick: true },
      );
    } else {
      toast.update(toastId, {
        render: (
          <ProgressBarNotification
            progress={typeof progressOrMsg === "number" ? progressOrMsg : 0}
            done={done}
            error={error}
            message={typeof progressOrMsg === "string" ? progressOrMsg : null}
          />
        ),
        autoClose: error ? 3000 : done ? 2000 : false,
      });
    }
  };

  const ProgressBarNotification = ({ progress, done, error, message }) => (
    <div className="app-notification-container mt-22">
      <div className="d-flex align-items-center gap-2">
        <img src={LogoSmall} width={35} alt="" />
        <div className="d-flex flex-column gap-1 w-100">
          <div>
            {error
              ? message || "Upload document failed!"
              : done
                ? "Document uploaded successfully!"
                : "Your document is loading..."}
          </div>
          {!done && !error && (
            <ProgressBar now={progress} className="notification-progress-bar" />
          )}
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    if (fetchSpireFolderDocumentsRes?.status === true) {
      const rootFolder = fetchSpireFolderDocumentsRes.data;
      setFetchFolderData(rootFolder);
      // renderStructure(fetchSpireFolderDocumentsRes.data);
      props.childData(rootFolder);
      console.log("asc22 fetch data", fetchSpireFolderDocumentsRes.data);
    }
  }, [fetchSpireFolderDocumentsRes]);

  useEffect(() => {
    if (fileChunkCompleteRes === "not working") {
      console.log("asc multi img", fileChunkCompleteRes);

      const payload = convertTreeToPayload(
        folderStructure,
        fileChunkCompleteRes,
      );
      console.log("asc payload", payload);

      if (payload[0]?.type === "file") {
        setIsRootFileAdding(true);
      }

      if (payload[0]?.type === "folder") {
        setIsFolderAdding(true);
      }

      if ((isFolderAdding || payload[0]?.type === "folder") && !folderID) {
        // dispatch(DriveAdd(payload));
        dispatch(DriveAdd(payload[0]));
        props?.loader(true);
      }

      if ((isFolderAdding || payload[0]?.type === "folder") && folderID) {
        dispatch(DriveUpdate(payload[0]));
        props?.loader(true);
      }

      if (isRootFileAdding && currentFile && payload[0]?.type === "file") {
        const rootFilePayload = {
          folderid: folderID && folderID,
          documentname: currentFile[0]?.name,
          documentextension: currentFile[0]?.type,
          documentcontent: "string",
          link: multipleUploadToS3Res[0],
          documentsize: currentFile[0]?.size,
        };
        // dispatch(AddRootDoc(rootFilePayload));
      }

      setTimeout(() => {
        setShowLoader(false);
        // setIsRootFileAdding(false);
        // setIsFolderAdding(false);
        setCurrentFile(null);
      }, 1000);
    } else {
      console.log("asc error", fileChunkCompleteRes);
      setErrorMsg(fileChunkCompleteRes?.message);
      setShowLoader(false);
      if (fileChunkCompleteRes?.message) {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: fileChunkCompleteRes?.message,
          },
          false,
        );
      }
    }
  }, [fileChunkCompleteRes]);

  // on drag start
  const [isDragging, setIsDragging] = useState(false);
  const [add_image, setAdd_image] = useState("");

  const onDrag_handleFileUpload = async (files, item) => {
    if (!files) return;
    const formData = new FormData();
    formData.append("files", files);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      setAdd_image(response.data[0]);

      setTimeout(() => {
        // dispatch(UpdateProjectCover(item.projectid, response.data[0]));
        console.log("asc2");
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };
  // on drag end

  const outFolderRef = useRef(false);

  // converting in json structure start
  const handleFolderUpload = async (e) => {
    let files = [];

    // Start loader
    // setShowLoader(true);

    // Drag-and-drop case
    if (e.dataTransfer && e.dataTransfer.items) {
      const items = e.dataTransfer.items;

      const traverseFileTree = (item, path = "") => {
        return new Promise((resolve) => {
          if (item.isFile) {
            item.file((file) => {
              file.relativePath = path + file.name;
              resolve([file]);
            });
          } else if (item.isDirectory) {
            const dirReader = item.createReader();
            let entries = [];

            const readEntries = () => {
              dirReader.readEntries(async (results) => {
                if (!results.length) {
                  const allFiles = await Promise.all(
                    entries.map((entry) =>
                      traverseFileTree(entry, path + item.name + "/"),
                    ),
                  );
                  resolve(allFiles.flat());
                } else {
                  entries = entries.concat(Array.from(results));
                  readEntries();
                }
              });
            };

            readEntries();
          }
        });
      };

      const promises = [];
      for (let i = 0; i < items.length; i++) {
        const entry = items[i].webkitGetAsEntry();
        if (entry) promises.push(traverseFileTree(entry));
      }

      const allFiles = (await Promise.all(promises)).flat();
      files = allFiles;
    }

    // Input field case
    else if (e.target && e.target.files) {
      files = Array.from(e.target.files);
    }

    if (!files) return;

    // const files = Array.from(e.target.files);
    const foldersTree = {};

    files.forEach((item) => {
      // const pathParts = item.webkitRelativePath.split("/"); // for file only
      const path =
        item.webkitRelativePath || item.relativePath || item.name || "";
      const pathParts = path.split("/");

      let current = foldersTree;

      pathParts?.forEach((part, i) => {
        if (i === pathParts.length - 1) {
          // if (!current?.files) current.files = [];
          if (!Array.isArray(current.files)) current.files = [];
          current.files.push({
            fileName: item.name,
            fileSize: item.size,
            fileType: item.type,
          });
        } else {
          if (!current[part]) current[part] = {};
          current = current[part];
        }
      });
    });

    // log only once after entire folder is processed
    console.log("asc2 Folder tree JSON", foldersTree);
    setFolderStructure(foldersTree);

    // Prepare and Upload Files to S3
    if (isFolderAdding === "delete this block") {
      showOrUpdateUploadToast(0, false); // notification.

      setTimeout(() => {
        // dispatch(multipleUploadToS3(Array.from(e.target.files)));
        // dispatch(multipleUploadToS3(files, setFolderProgress)); //old
        // progress callback se update karo👇
        dispatch(
          multipleUploadToS3(files, (progress) => {
            showOrUpdateUploadToast(progress, progress === 100);
          }),
        );
      }, 1000);
    }

    // chunk payload start
    setTimeout(async () => {
      try {
        progressCountRef.current = { part: 0, total: files.length }; // store number of parts uploading and total files.👆
        const uploadedFiles = [];
        for (const file of files) {
          const s3Link = await uploadFileToS3Multipart(file, dispatch);
          uploadedFiles.push({ ...file, link: s3Link });

          // store number of parts uploading and total files.👇
          progressCountRef.current = {
            ...progressCountRef.current,
            part: progressCountRef.current.part + 1,
            //  total: files.length,
          };
        }

        // dispatch(multipleUploadToS3(uploadedFiles));

        // final payload 👇
        const payload = convertTreeToPayload(foldersTree, uploadedFiles);

        console.log("asc payload", payload);
        if (payload[0]?.type === "folder" && !folderID) {
          dispatch(DriveAdd(payload[0])); // ab sirf ek hi bar chalega
          props?.loader(true);
        }

        if (payload[0]?.type === "folder" && folderID) {
          dispatch(DriveUpdate(payload[0]));
          props?.loader(true);
        }

        if (payload[0]?.type === "file") {
          const chunkFilePayload = {
            folderid: folderID && folderID,
            documentname: payload[0]?.name,
            documentextension: payload[0]?.type,
            documentcontent: "string",
            link: payload[0]?.link,
            documentsize: payload[0]?.size,
          };

          const chunkFilePayload2 = {
            folderid: folderID && folderID,
            rootDocs: payload.map((x) => ({
              documentname: x.name,
              documentextension: x.type,
              // documentcontent: "string",
              documentcontent: getMimeType(x),
              link: x.link,
              documentsize: x.size,
            })),
          };
          dispatch(AddRootDoc(chunkFilePayload2));
        }

        // ajit api payload start
        if (payload[0]?.type === "folder") {
          // dispatch(ajitJsonSpireApi(payload[0]));
          // dispatch(
          //   ajitJsonSpireApi({
          //     ...payload[0],
          //     workspace: workspaceName,
          //   }),
          // );
          dispatch(
            ajitJsonSpireApi({
              payload: {
                ...payload[0],
                data: "Genric",
                ENV: process.env.REACT_APP_API_URL,
              },
            }),
          );
        }

        if (payload[0]?.type === "file") {
          let ajitPayload = {
            name: "",
            // workspace: workspaceName,
            type: "folder",
            // children: payload.map((x) => ({
            //   documentcontent: "string",
            //   documentextension: "file",
            //   documentname: x.name,
            //   documentsize: x.size,
            //   link: x.link,
            // })),
            children: payload.map((x) => ({
              name: x.name,
              type: x.type,
              // extension: "file",
              extension: x.extension,
              size: x.size,
              link: x.link,
            })),
          };

          let ajitPayload2 = payload.map((x) => ({
            payload: {
              documentLink: x.link,
              docName: x.name,
              data: "Genric",
              ENV: process.env.REACT_APP_API_URL,
            },
          }));

          dispatch(ajitJsonSpireApi(ajitPayload2));
        }
        // ajit api payload end

        setTimeout(() => {
          setShowLoader(false);
          setIsRootFileAdding(false);
          setIsFolderAdding(false);
          setCurrentFile(null);
        }, 1000);
      } catch (err) {
        console.error("Upload failed:", err);
        setShowLoader(false);
      }
    }, 1000);
    // chunk payload end
  };
  // converting in json structure end

  // file chunk start
  const uploadFileToS3Multipart = async (file, dispatch) => {
    const chunkSize = 50 * 1024 * 1024; // 10 MB
    showOrUpdateUploadToast(0); // notification.

    // Step 1: Start upload
    const { uploadId } = await dispatch(
      fileChunkStart(file.name, file.size, file.type),
    );

    const totalParts = Math.ceil(file.size / chunkSize);
    const uploadedParts = [];

    // Helper function: retry logic
    async function uploadWithRetry(url, blob, retries = 3, delay = 1000) {
      for (let attempt = 1; attempt <= retries; attempt++) {
        try {
          const res = await fetch(url, { method: "PUT", body: blob });
          if (!res.ok) throw new Error(`Upload failed with ${res.status}`);
          return res;
        } catch (err) {
          if (attempt < retries) {
            console.warn(`Retrying part... attempt ${attempt}`);
            await new Promise((r) => setTimeout(r, delay));
          } else {
            throw err;
          }
        }
      }
    }

    for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
      const start = (partNumber - 1) * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const blob = file.slice(start, end);

      try {
        // Step 2: Get presigned URL
        const { url } = await dispatch(
          filePresign(file.name, uploadId, partNumber),
        );

        // Upload to S3
        // const uploadRes = await fetch(url?.result, { method: "PUT", body: blob });
        // Step 2: Upload with retry
        const uploadRes = await uploadWithRetry(url?.result, blob, 3, 2000);

        uploadedParts.push({
          PartNumber: partNumber,
          // ETag: uploadRes.headers.get("ETag"),
          ETag: uploadRes.headers.get("ETag")?.replace(/"/g, ""),
        });

        // notification.
        showOrUpdateUploadToast(Math.round((partNumber / totalParts) * 100));
      } catch (error) {
        console.error(`Part ${partNumber} upload failed:`, error);
        showOrUpdateUploadToast(
          // `Part ${partNumber} failed after retries.`,
          // `Upload failed! Please try again.`,
          `⚠️ Upload failed! Please try again or check your internet connection.`,
          false,
          true, // error=true
        );

        // Abort upload
        throw new Error(
          `Upload aborted at part ${partNumber}: ${error.message}`,
        );
        //  return null;
      }
    }

    // Step 3: Complete upload
    const payload = {
      fileName: file.name,
      uploadId,
      // parts: uploadedParts.map((part, index) => ({
      //   partNumber: index + 1,
      //   eTag: part.ETag || part.eTag,
      // })),
    };
    console.log("asc uploadedParts", uploadedParts);
    const { fileUrl } = await dispatch(fileChunkComplete(payload));
    setShowLoader(false);
    showOrUpdateUploadToast(100, true); // notification Success message.

    return fileUrl; // final S3 link
  };
  // file chunk end

  // example for "Object.entries" start 👇
  const fruit = {
    name: "Mango",
    color: "Yellow",
    taste: "Sweet",
  };
  // if we write "Object.entries" 👇
  Object.entries(fruit);
  // output like "key","value" for map()👇
  // [
  //   ["name", "Mango"],
  //   ["color", "Yellow"],
  //   ["taste", "Sweet"],
  // ];
  // example for "Object.entries" end 👆

  const renderStructure = (obj, level = 0) => {
    return Object.entries(obj).map(([key, value]) => {
      if (key === "files") {
        return value.map((item, index) => (
          <div key={index} style={{ marginLeft: level * 20 + 20 }}>
            📄 {item.fileName} &nbsp; {roundFileSize(item.fileSize)}
          </div>
        ));
      }
      return (
        <div key={key}>
          <div style={{ marginLeft: level * 20 }}>📁 {key}</div>
          {renderStructure(value, level + 1)}
        </div>
      );
    });
  };

  const renderStructure2 = (node, level = 0) => {
    if (!node) return null;

    if (Array.isArray(node)) {
      return node.map((child) => renderStructure2(child, level));
    }

    if (node.type === "folder") {
      return (
        <div key={node.name}>
          <div style={{ marginLeft: level * 20, fontWeight: "bold" }}>
            📁 {node.name}
          </div>
          {renderStructure2(node.children, level + 1)}
        </div>
      );
    }

    if (node.type === "file") {
      return (
        <div key={node.name} style={{ marginLeft: level * 20 }}>
          📄 {node.name} {node.size}
        </div>
      );
    }

    return null;
  };

  const convertTreeToPayload = (obj, uploadedFilesUrls) => {
    if (!obj || typeof obj !== "object") return [];
    if (!Array.isArray(uploadedFilesUrls)) uploadedFilesUrls = [];
    const result = [];
    Object.entries(obj).forEach(([key, value]) => {
      if (key === "files") {
        value.forEach((item, index) => {
          const matchedUrl = uploadedFilesUrls.find((x) =>
            x.link.includes(item.fileName),
          );

          result.push({
            name: item.fileName?.split(".", 1)[0],
            extension: item.fileName?.split(".", 2)[1],
            type: "file",
            size: roundFileSize(item.fileSize),
            // s3Key: matchedUrl?.s3Key || "",
            link: matchedUrl?.link || "",
          });
        });
      } else {
        result.push({
          folderid: folderID && folderID,
          name: key,
          type: "folder",
          children: convertTreeToPayload(value, uploadedFilesUrls),
        });
      }
    });

    return result;
  };

  const getMimeType = (file) => {
    const ext = file.extension?.toLowerCase();

    const mimeTypes = {
      pdf: "application/pdf",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      xls: "application/vnd.ms-excel",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      doc: "application/msword",
      pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ppt: "application/vnd.ms-powerpoint",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
    };

    return mimeTypes[ext] || "string";
  };

  return (
    <>
      {showLoader && (
        <div
          className="ocr-page-loader bg-transparent"
          style={{ top: "5px", left: "90px" }}
        >
          <Loader />
        </div>
      )}

      <div
        className={`py-5 dragDiv mt-2 mx-5 ${isDragging ? "dragging" : ""}`}
        // style={{ width: "95%", height: "65vh" }}
        onDragEnter={(e) => {
          e.preventDefault();
          setIsDragging(true); // 👈 Jab drag start ho
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setIsDragging(false); // 👈 Jab drag bahar chala jaaye
        }}
        // on drag upload img start
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true); // 👈 set to true when dragging.
        }}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false); // 👈 reset when drag leaves.
          const droppedFile = Array.from(e.dataTransfer.files);
          // handleFileUpload(e);
          handleFolderUpload(e);
          if (droppedFile) {
            // onDrag_handleFileUpload(droppedFile[0], "item");
            // dispatch(filesInsertDocToS3(droppedFile));
            setCurrentFile(droppedFile);
          }
        }}
        // on drag upload img end
      >
        <div className="dottedPlusDiv m-auto" ref={Ankit}>
          <img
            src={AIicon}
            alt=""
            className="mt-4"
            style={{
              width: "30px",
              height: "40px",
            }}
          />

          <p
            className="mb-0 py-2"
            style={{ fontSize: "14px", color: "#333333", fontWeight: 600 }}
          >
            {/* Drag & Drop documents */}
            {t("Drag & Drop documents")}
            <br />
            {/* to create a new AI Folder */}
            {t("to create a new AI Folder")}
          </p>

          <img
            src={PlusImg2}
            alt=""
            className="pointer mt-2 opacity-75"
            style={{
              width: "25px",
              height: "25px",
              position: "relative",
            }}
            onClick={() => {
              // hidden_Input_File.current.click();
              setFileFolderPopup(true);
            }}
          />

          {fileFolderPopup && (
            <ClickAwayListener onClickAway={() => setFileFolderPopup(false)}>
              <div className="fileFolderPopupDiv">
                <p
                  className="mb-1 ps-5 fileUpload"
                  onClick={() => {
                    single_Input_File.current.click();
                    setIsRootFileAdding(true);
                    setFileFolderPopup(false);
                  }}
                >
                  <FileImageOutlined style={{ fontSize: 22 }} />
                  <span className="ps-2">
                    {/* File Upload */}
                    {t("File Upload")}
                  </span>
                </p>
                <p
                  className="mt-0 ps-5 fileUpload"
                  onClick={() => {
                    hidden_Input_File.current.click();
                    setIsFolderAdding(true);
                    setFileFolderPopup(false);
                  }}
                >
                  <FolderOutlined style={{ fontSize: 22 }} />
                  <span className="ps-2">
                    {/* Folder Upload */}
                    {t("Folder Upload")}
                  </span>
                </p>
              </div>
            </ClickAwayListener>
          )}

          <div>
            <input
              multiple
              webkitdirectory="true" // for upload folder
              directory="true" // for upload folder
              type="file"
              accept="image/*,.doc,.pdf"
              ref={hidden_Input_File}
              style={{ display: "none" }}
              onChange={(e) => {
                const singleFile = e.target.files[0];
                const fileLoaded = URL.createObjectURL(singleFile); // make temporary local URL to show img in src.
                // setAdd_image(fileLoaded)
                // handleFileUpload(e);
                console.log("asc single file", singleFile);
                // dispatch(singleUploadToS3(singleFile));
                handleFolderUpload(e);

                // for multiple files uploads👇
                const multipleFiles = e.target.files;
                // setAttachments(Array.from(multipleFiles));
                console.log("asc multiple files", singleFile);
                if (multipleFiles.length > 0) {
                  // dispatch(
                  //   multipleUploadToS3(Array.from(multipleFiles), setUploadProgress)
                  // );
                  // onFileUploaded(Array.from(multipleFiles));
                  // handleNotification(Array.from(multipleFiles));
                }
                // ✅ Reset input value so same file can be selected again
                e.target.value = "";
              }}
            />
          </div>

          {/* for direct files only*/}
          <div>
            <input
              multiple
              type="file"
              accept="image/*,.doc,.pdf"
              ref={single_Input_File}
              style={{ display: "none" }}
              onChange={(e) => {
                const singleFile = e.target.files[0];
                const fileLoaded = URL.createObjectURL(singleFile); // make temporary local URL to show img in src.
                // setAdd_image(fileLoaded)
                // handleFileUpload(e);
                console.log("asc single file", singleFile);
                // dispatch(singleUploadToS3(singleFile));
                handleFolderUpload(e);

                // for multiple files uploads👇
                const multipleFiles = Array.from(e.target.files);
                // setAttachments(multipleFiles);
                console.log("asc multiple files", singleFile);
                if (multipleFiles.length > 0) {
                  // dispatch(
                  //   multipleUploadToS3(multipleFiles, setUploadProgress)
                  // );
                  // onFileUploaded(Array.from(multipleFiles));
                  // handleNotification(Array.from(multipleFiles));
                  // dispatch(filesInsertDocToS3(multipleFiles));
                  setCurrentFile(multipleFiles);
                }
                // ✅ Reset input value so same file can be selected again
                e.target.value = "";
              }}
            />
          </div>
        </div>

        <div className="d-none">
          {renderStructure(folderStructure)}
          {fetchFolderData ? renderStructure2(fetchFolderData) : "Loading..."}
        </div>
      </div>
    </>
  );
};

export default DragDropSpireAi;
